export { default } from "~components/modules/single-story/variants/image-left/SingleStoryImageLeft.integrity";
